import './Impact.scss';

// First of three sections that used to be one oversized block: this is "why
// video at all", UseCases is "what you'd make", Milestones is "when it isn't
// about return". Splitting them let each one land where it belongs in the page
// rather than stacking four arguments above the fold of Process.
//
// On statistics: only one goes on this page, and it is current, named, and
// linkable. The circulating video-efficacy numbers were researched and rejected
// — see CLAUDE.md before adding another.
// Evidence for the section header rather than for any one card. It lived inside
// the third card at first, which made that card taller than its two neighbours
// and read as lopsided — and the claim it supports is the thesis above, not a
// single point below.
//
// This is the ONLY borrowed statistic on the site. It ships with a visible
// linked citation and it stays that way. The rest of the circulating
// video-efficacy numbers were researched and rejected — see CLAUDE.md before
// adding another.
const HEADLINE_STAT = {
    value: "63%",
    label: `say a short video is how they'd most like to learn about something.
            Text articles come second, at 12%.`,
    source: "Wyzowl, 2026",
    url: "https://wyzowl.com/video-marketing-statistics/",
};

// Three distinct claims: attention, the ask, and control of the message. The
// first two of these used to be one idea said twice — "it holds people longer"
// and "people would rather watch" are the same argument, so they're one card
// now and consistency took the empty slot.
//
// `stat` stays available per card for real client numbers later, but fill all
// three or none: one card carrying a figure is what made this section look
// asymmetric in the first place.
const IMPACT = [
    {
        title: "People would rather watch",
        body: `A newsletter gets skimmed and a flyer gets set down. Film is the
               format your audience actually chooses, and it asks two minutes of
               someone who was never going to read the page.`,
        stat: null,
    },
    {
        title: "It makes the ask when you can't",
        body: `A campaign needs its case made over and over — in living rooms, from
               the podium, in the follow-up email. On film the ask arrives whole every
               time, whether or not you're the one in the room to deliver it.`,
        stat: null,
    },
    {
        title: "The message stops drifting",
        body: `Once it's cut, it says the same thing every time, in the words you'd
               have chosen. Staff and volunteers stop improvising it, and the version
               a stranger meets first is the version you meant.`,
        stat: null,
    },
];

function Impact() {
    return (
        <div className="Impact" id="impact">
            <div className="Impact-header-container reveal">
                <span className="Impact-eyebrow">Why video</span>
                <h2 className="Impact-header">
                    Video is how people <span>take things in now.</span>
                </h2>
                <p className="Impact-lead">
                    Email and a website still matter. They just aren't where attention
                    goes anymore.
                </p>
            </div>

            <div className="Impact-stat reveal">
                <b>{HEADLINE_STAT.value}</b>
                <span>{HEADLINE_STAT.label}</span>
                <cite>
                    <a href={HEADLINE_STAT.url} target="_blank" rel="noopener noreferrer">
                        {HEADLINE_STAT.source}
                    </a>
                </cite>
            </div>

            {IMPACT.map((item, index) => (
                <div
                    key={item.title}
                    className={`Impact-card reveal ${index ? `delay-${index}` : ""} ${["left", "center", "right"][index]}-card`}>

                    <span className="Impact-card-index" aria-hidden="true">
                        {String(index + 1).padStart(2, "0")}
                    </span>

                    <h3>{item.title}</h3>
                    <p>{item.body}</p>

                    {/* Kept for real client numbers later — see the note on the
                        IMPACT array about filling all three or none. */}
                    {item.stat ? (
                        <div className="Impact-card-stat">
                            <b>{item.stat.value}</b>
                            <span>{item.stat.label}</span>
                        </div>
                    ) : null}
                </div>
            ))}

            {/* A first-person claim about his own parish work, not a client
                testimonial. Stays unquantified on purpose.

                This blockquote is the ONLY first-person copy on the site — it is a
                quotation with a byline, not the site narrating. Everything else
                speaks as "we" (Candlelyte) or, on /founder, in the third person. A
                quote rewritten in third person stops being a quote, which is why
                this one is exempt. Don't "fix" it for consistency. */}
            <figure className="Impact-note reveal">
                <blockquote>
                    I started making videos for my own parish, and they worked. They helped
                    raise real money, and that money went back into reaching more souls for Christ.
                </blockquote>
                <figcaption>Johnathan Geiger <span>Founder, Candlelyte Productions</span></figcaption>
            </figure>
        </div>
    );
}

export default Impact;
